/*
=========================================================
* RingOperator — Animated Waveform primitive
=========================================================
*/

import { useEffect, useMemo, useState } from "react";

function Waveform({ bars = 48, color = "currentColor", height = 120, active = true, speed = 1, variance = 1 }) {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!active) return;
    let raf;
    const start = performance.now();
    const loop = (t) => {
      setTick((t - start) / 1000);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, [active]);

  const values = useMemo(
    () =>
      Array.from({ length: bars }, (_, i) => ({
        phase: (i / bars) * Math.PI * 2,
        seed: Math.sin(i * 127.1) * 0.5 + 0.5,
      })),
    [bars]
  );

  return (
    <svg
      viewBox={`0 0 ${bars * 8} ${height}`}
      style={{ width: "100%", height: "100%", display: "block" }}
      preserveAspectRatio="none"
    >
      {values.map((v, i) => {
        const t = tick * speed;
        const amp =
          (Math.sin(t * 2.1 + v.phase * 3) * 0.35 +
            Math.sin(t * 3.7 + v.phase * 1.2) * 0.25 +
            Math.sin(t * 1.3 + v.phase * 0.7) * 0.25 +
            v.seed * 0.25) *
          variance;
        const normalized = Math.max(0.08, Math.min(1, 0.5 + amp));
        const h = normalized * (height * 0.9);
        const y = (height - h) / 2;
        return (
          <rect
            key={i}
            x={i * 8 + 1.5}
            y={y}
            width={5}
            height={h}
            rx={2.5}
            fill={color}
            opacity={0.55 + 0.45 * normalized}
          />
        );
      })}
    </svg>
  );
}

export default Waveform;
